import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const Sidebar = () => {
  const { i18n } = useTranslation();
  const isAdmin = true;

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="w-64 bg-gray-800 text-white h-screen fixed top-0 left-0">
      <div className="p-4 text-xl font-bold border-b border-gray-700">
        MyReadingApp
      </div>
      <ul className="p-4 space-y-4">
        <li>
          <Link to="/" className="hover:text-gray-300">
            Home
          </Link>
        </li>
        <li>
          <Link to="/bookmarks" className="hover:text-gray-300">
            Bookmarks
          </Link>
        </li>
        <li>
          <Link to="/favorites" className="hover:text-gray-300">
            Favorites
          </Link>
        </li>
        <li>
          <Link to="/offline-chapters" className="hover:text-gray-300">
            Offline Chapters
          </Link>
        </li>
        <li>
          <Link to="/suggest-ending" className="hover:text-gray-300">
            AI Story Ending
          </Link>
        </li>
        <li>
          <select onChange={(e) => changeLanguage(e.target.value)} defaultValue="vi" className="bg-gray-700 text-white p-2 rounded">
            <option value="vi">Tiếng Việt</option>
            <option value="en">English</option>
            <option value="fr">Français</option>
          </select>
        </li>
        {/* <li>
          <Link to="/settings" className="hover:text-gray-300">
            Settings
          </Link>
        </li> */}
        {
          isAdmin && (
            <li>
              <Link to="/admin" className="hover:text-gray-300">
                Admin
              </Link>
            </li>
          )
        }
      </ul>
    </div>
  );
};

export default Sidebar;